import { clsx, type ClassValue } from "clsx"
import tw, { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
